import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from '../../components/index';

const ModalAlerta = (props) => {
  const montaAlerta = alerta => (
    <div style={{ 'text-align': 'justify', 'font-weight': '300' }}>
      {alerta.descricao}
    </div>
  );

  const montaListaAlertas = () => {
    const listaRelacoes = [];
    props.alertas.forEach((alerta) => {
      listaRelacoes
        .push(montaAlerta(alerta));
    });
    return listaRelacoes;
  };

  const montaModalContent = () => (
    <React.Fragment>
      {montaListaAlertas()}
    </React.Fragment>
  );

  const modalFooter = (
    <React.Fragment>
      <div className="right">
        {!props.esconderBotaoCancelar ?
          <Button
            title={props.labelBotaoCancelarAcao ? props.labelBotaoCancelarAcao : 'Cancelar'}
            onClick={props.handleModal}
            hint={props.labelBotaoCancelarAcao ? props.labelBotaoCancelarAcao : 'Cancelar'}
          />
        : '' }
        <Button
          className="dtp-primary"
          title={props.labelBotaoConfirmarAcao ? props.labelBotaoConfirmarAcao : 'Confirmar ação'}
          onClick={props.aceitar}
        />
      </div>
    </React.Fragment>
  );

  return (
    <Modal
      {...props}
      alert
      alertType="warning"
      conteudomodal={montaModalContent()}
      conteudofooter={modalFooter}
      onHide={props.handleModal}
      showTitle
      size={props.tamanho ? props.tamanho : 'lg'}
      title={props.labelTitulo ? props.labelTitulo : 'Confirma a ação?'}
      showModal
    />
  );
};

ModalAlerta.propTypes = {
  handleModal: PropTypes.func.isRequired,
  aceitar: PropTypes.func.isRequired,
  alertas: PropTypes.arrayOf({ descricao: PropTypes.string }).isRequired,
  labelTitulo: PropTypes.string.isRequired,
  labelBotaoConfirmarAcao: PropTypes.string.isRequired,
  labelBotaoCancelarAcao: PropTypes.string.isRequired,
  esconderBotaoCancelar: PropTypes.bool.isRequired,
  tamanho: PropTypes.string.isRequired,
};

export default ModalAlerta;



// WEBPACK FOOTER //
// ./src/pages/requerimentos/ModalAlerta.jsx